// extracted by mini-css-extract-plugin
export default {"navcontent":"HeaderSubPart_navcontent__fHcVL"};